import * as K from '../../constants/k';
import AndroidFileManger from './AndroidFileManger';
import IosFileManger from './IosFileManger';
import { Customer, Paykey, user } from '../../utils/DictionaryManagementUtils';

const mainConfigurationsName = 'WTMainConfigurations';

export default function DatabaseHandler(serverGate, selectedUser, snapshotsOnboarding) {
  this.serverGate = serverGate;
  this.selectedUser = selectedUser;
  this.androidFileManger = new AndroidFileManger(this, snapshotsOnboarding);
  this.iosFileManger = new IosFileManger(this, snapshotsOnboarding);

  this.handleExporting = async (exportOptions, configurations) => {
    await this.exportJSON(this.selectedUser.userConfigs[0], mainConfigurationsName);

    await exportToDatabase(exportOptions, configurations);
  };

  const exportToDatabase = async (exportOptions, configurations) => {
    const promiseArray = [];
    if (exportOptions.forAndroid) {
      await this.androidFileManger.exportFiles(configurations, exportOptions);
    }
    if (exportOptions.forIOS) {
      promiseArray.concat(this.iosFileManger.exportFiles(configurations, exportOptions));
    }
    await Promise.all(promiseArray);
  };

  const getFirebasePath = () => {
    const userTypeFolder = getBaseFolder();
    const userVersion = this.selectedUser.userConfigs[0].firebase_version_path;
    return `${userTypeFolder}/${this.selectedUser.userUsername}/${userVersion}/`; // userTypeFolder/userName/wtVersion.firebaseVersion
  };

  const getBaseFolder = () => (this.selectedUser.userType === user ? Customer : Paykey);

  this.exportXML = async (configurationsXml, fileName) => {
    const metadata = {
      contentType: 'application/xml',
    };
    await this.serverGate.getStorageRef()
      .child(`${getFirebasePath()}${fileName}`)
      .putString(configurationsXml, 'raw', metadata);
  };

  this.exportJSON = async (configurationsJson, fileNamePrefix) => {
    const metadata = {
      contentType: 'application/json',
    };
    await this.serverGate.getStorageRef()
      .child(`${getFirebasePath()}${fileNamePrefix}.json`)
      .putString(JSON.stringify(configurationsJson, null, 2), 'raw', metadata);
  };

  this.exportImage = async (imageUri, fileNamePrefix) => {
    const index = imageUri.indexOf(',');
    if (index !== -1) {
      const metadata = {
        contentType: K.FIREBASE_UPLOAD_MIME_TYPE,
      };
      const imageBase64 = imageUri.substring(index + 1);

      await this.serverGate.getStorageRef()
        .child(`${getFirebasePath()}${fileNamePrefix}.${K.IMAGE_FILE_EXT}`)
        .putString(imageBase64, 'base64', metadata);
    }
  };

  this.exportFont = async (fontUri, fileNamePrefix, fileType) => {
    const index = fontUri.indexOf(',');
    if (index !== -1) {
      const metadata = {
        contentType: `font/${fileType}`, // add file type (ttf/oft)
      };
      const imageBase64 = fontUri.substring(index + 1);

      await this.serverGate.getStorageRef()
        .child(`${getFirebasePath()}${fileNamePrefix}.${fileType}`)
        .putString(imageBase64, metadata);
    }
  };
}
